var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_pencil",
    transform: "translate(-482 -863)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(482 863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "create-24px_1_",
    "data-name": "create-24px (1)",
    transform: "translate(489.994 871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26873",
    "data-name": "Path 26873",
    d: "M0,0H20V20H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26874",
    "data-name": "Path 26874",
    d: "M3,14.874V18H6.125L15.34,8.783,12.216,5.658Zm2.433,1.458H4.666v-.767l7.549-7.549.767.767ZM17.757,5.191l-1.95-1.95a.835.835,0,0,0-1.175,0L13.107,4.766l3.125,3.125,1.525-1.525a.83.83,0,0,0,0-1.175Z",
    transform: "translate(-0.499 -0.499)",
    fill: "#343a40"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit_pencil.8c02e230e016e2c50b9290618c7a3da4.svg";
export { ForwardRef as ReactComponent };